import wixLocation from 'wix-location';
import wixWindow from 'wix-window';

let url = wixLocation.url
let language = wixWindow.multilingual.currentLanguage;

$w.onReady(function () {
if (language === "de"){
	$w("#Kontakten").collapse();
	$w("#KontaktDE").expand();
}
if (language === "en"){
	$w("#KontaktDE").collapse();
	$w("#Kontakten").expand();
}
})